import { throttleTime } from "rxjs/operators";
import { Component } from "@angular/core";
import { WindowsNotificationService } from "../../../services/windows-notification.service";
import { ReportsService } from "../../../services/reports.service";
import { UserService } from "../../../domain/user-service";

@Component({
  selector: "missing-audios-report",
  templateUrl: "./missing-audios-report.component.html",
  styleUrls: ["./missing-audios-report.component.scss"],
})
export class MissingAudiosReportComponent {
  showPreloader: boolean;
  rows = [];
  selected = [];
  columns = [
    { name: "ID", prop: "customId" },
    { name: "Missing Audios", prop: "missingAudios" },
    { name: "Media Title", prop: "mediaTitle" },
  ];

  constructor(
    private windowsNotificationService: WindowsNotificationService,
    private reportsService: ReportsService,
    private userService: UserService,
  ) {
    windowsNotificationService.ACTIONS.showMissingAudiosReport.subscribe(() => {
      this.loadReport();

      console.log("refreshing the report");

      let globalState = this.reportsService.reportsGlobalState
        .pipe(throttleTime(3000))
        .subscribe(() => {
          this.loadReport();
        });

      //clean up listeners
      windowsNotificationService.ACTIONS.closeMissingAudiosReport
        .subscribe(() => {
          globalState.unsubscribe();
        })
        .unsubscribe();
    });
  }

  clickOnCloseBtnHandler() {
    this.windowsNotificationService.ACTIONS.closeMissingAudiosReport.next(true);
  }

  private loadReport() {
    this.showPreloader = true;

    this.userService.getCurrentChannel().then(({ id }) => {
      this.reportsService.getMissingAudiosReport(id).then((report) => {
        this.rows = this.mapDtos(report);

        this.showPreloader = false;
      });
    });
  }

  private mapDtos(report: Array<any>) {
    return report.map((entry) => {
      let dto: any = { ...entry };

      return dto;
    });
  }
}
